import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import { ThreadProps } from '../../types';
import s from './CardLayoutThread.scss';

const CardLayoutThread: React.FC<ThreadProps> = props => {
  return (
    <SimpleThread
      {...props}
      className={classnames(s['card-layout'], props.className)}
      commentBoxWrapperClassName={classnames(s['commentbox-wrapper'])}
      threadStackClassName={s['thread-stack']}
      headerClassName={s['header']}
      scrollableClassName={s['scrollable']}
      replyIndentModifier={0}
    />
  );
};
CardLayoutThread.displayName = 'CardLayoutThread';

export default CardLayoutThread;
